<template>
  <div class="flow-main" id="create-symbol-flow">
    <van-popup
        v-model="show"
        :closeable="!$route.query.isApp"
        :overlay="false"
        :close-icon="isDirection ? 'arrow' : 'arrow-left'"
        :close-icon-position="isDirection ? 'top-right' : 'top-left'"
        position="right"
        class="tip-popup"
        @click-close-icon="handleClose"
        :style="{ height: '100%',width: '100%' }"
    >
      <h1 class="tip-popup-title">{{ $t('8000118') }}
        <a @click="handleFAQ" class="FAQ-btn">FAQ?</a>
      </h1>
      <div class="tip-popup-description">
        <!--SuperEx上币：0上币费用！0沟通成本！ 1分钟即可完成交易所上币，还可享受最高80%的收益分红-->
        <p class="content" v-html="$t('8000121')"></p>
        <div class="step-content">
          <p>{{ $t('8000127') }}</p>
          <p>{{ $t('8000131') }}</p>
          <p>{{ $t('8000133') }}</p>
          <p>{{ $t('8000136') }}</p>
        </div>
      </div>
      <van-button type="primary" size="large" :loading="buttonLoading" @click="handleClick">{{ $t('8000139') }}
      </van-button>
    </van-popup>
    <div class="flow-main-title">
      <van-icon v-if="!$route.query.isApp" :name="isDirection ? 'arrow' : 'arrow-left'" @click="handleClose"/>
      <h1>{{ $t('8000078') }}</h1>
    </div>
    <step-view :currentStep="currentStep"/>
    <first-step ref="firstStepDemo" v-show="currentStep == 1" @handleNextStep="nextStep"/>
    <second-step ref="secondStepDemo" v-show="currentStep == 2" :clearTemp="clearTemp" @handleNextStep="nextStep"
                 @handlePrev="prevStep"/>
    <third-step ref="thirdStepDemo" v-show="currentStep == 3" :createSubmitStatus="createSubmitStatus" @handleNextStep="nextStep" @handlePrev="prevStep"/>
    <fourth-step ref="fourthStepDemo" v-show="currentStep == 4" @createFinish="handleCreateFinish"/>
    <van-popup v-model="tipsModel" class="msg-tip-popup" closeable close-icon="cross" close-icon-position="top-right">
      <div class="tip-message-box">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-tishi-1"></use>
        </svg>
        <p>{{ errorLimitMsg }}</p>
        <van-button @click="handleConfirm(buttonText)">{{ $t(buttonText) }}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {Popup, Button, Icon,Toast} from "vant";
import {mapGetters} from "vuex";
import stepView from "../../compontents/freeZone/createSymbol/stepView";
import firstStep from "../../compontents/freeZone/createSymbol/firstStep";
import secondStep from "../../compontents/freeZone/createSymbol/secondStep";
import thirdStep from "../../compontents/freeZone/createSymbol/thirdStep";
import fourthStep from "../../compontents/freeZone/createSymbol/fourthStep";
import {getCookie, removeCookie, removeToken, setCookie, setToken} from "../../utils/auth";
import {checkLimitApi,createApi,createMemo} from "../../api/spot";
import {parseTime} from "../../utils";

export default {
  name: "createSymbolFlow",
  components: {
    stepView,
    firstStep,
    secondStep,
    thirdStep,
    fourthStep,
    vanPopup: Popup,
    vanButton: Button,
    vanIcon: Icon
  },
  data() {
    return {
      show: true,
      temp: {
        address: ''
      },
      protocol: '',
      currencyAddress: '',
      imgs: '',
      upFee: '',
      existFlag: false,
      memo: '',
      currentStep: 1,
      clearTemp: false,
      currency: '',
      currencyId: '',
      memoId: '',
      isApp: '',
      isLogin: false, // 登录状态
      buttonLoading: false,
      tipsModel: false,
      errorLimitMsg: '',
      buttonText: '',
      FAQUrl: {
        'zh-TC': 'https://support.superex.com/hc/zh-hk/articles/36709698386969',
        en: 'https://support.superex.com/hc/en-001/articles/36710601297561',
        es: 'https://support.superex.com/hc/es/articles/36855693593881',
        fa: 'https://support.superex.com/hc/fa/articles/36856142384537',
        fr: 'https://support.superex.com/hc/fr/articles/36855883411481',
        ja: 'https://support.superex.com/hc/en-001/articles/36710601297561',
        ko: 'https://support.superex.com/hc/ko/articles/36854775950361',
        ru: 'https://support.superex.com/hc/ru/articles/36855057248025',
        uk: 'https://support.superex.com/hc/uk-ua/articles/36855256196505',
        vi: 'https://support.superex.com/hc/es/articles/36855693593881'
      },
      createSubmitStatus: false,
      language: ''
    }
  },
  computed: {
    ...mapGetters(['isDirection', 'token'])
  },
  created() {
    this.$store.dispatch('getLanguageList')
    this.resher()
  },
  watch: {
    $route() {
      this.resher()
    },
  },
  methods: {
    parseTime(time) {
      if (time == '' || !time) {
        return ''
      }else {
        return parseTime(time,'{y}-{m}-{d}')
      }
    },
    resher() {
      console.log(this.token, 'created----token')
      console.log(this.$route.path, 'this.$route.path')
      console.log(this.$route.query, 'this.$route.query')
      this.isApp = this.$route.query.isApp
      let token = this.$route.query.token || this.token
      setCookie('language', this.$route.query.language ? this.$route.query.language : 'en')
      this.language = this.$route.query.language ? this.$route.query.language : 'en'
      this.$store.dispatch('setIsDirection', this.$route.query.language == 'fa' ? true : false)
      window.document.documentElement.setAttribute('dir', this.isDirection ? 'rtl' : 'ltr')
      if (this.isApp == 1) {
        this.$i18n.locale = this.language
        if (token) {
          setToken(token)
          this.$store.dispatch('GetInfo', token)
          this.$store.dispatch('setToken', token)
          this.isLogin = true
        }else {
          removeToken()
          this.isLogin = false
        }
      }else {
        this.isLogin = getCookie('token') ? true : false
        if (this.isLogin) {
          // 不执行
        }else {
          removeToken()
        }
      }
    },
    handleClick() {
      posthog.capture('Button Clicked', {
        trigger:'h5_free_listing_intro_page_listing_button',
        name:'自由上币介绍页面-我要开始上币了按钮-H5'
      });
      this.buttonLoading = true
      if (this.$route.query.token || this.token) {
        checkLimitApi().then(res => {
          if (res.code == '601') {
            this.buttonLoading = false
            this.resultData = res.data
            this.tipsModel = true
            this.errorLimitMsg = this.$t('8000102',{resultData: this.resultData}) // 您的总资产折合需要大于{{resultData}}U后，才有资格创建交易对
            this.buttonText = '300102'
          } else if (res.code == '602') {
            this.buttonLoading = false
            this.tipsModel = true
            this.errorLimitMsg = this.$t('8000107') // 您当前是被限制用户，暂时无法创建新交易对，请明天再试。
            this.buttonText = '300141'
          } else if (res.code == '200') {
            this.show = false
            this.$refs.firstStepDemo.getChainList()
            if (this.isApp == 1) {
              this.$jsBridge.callHandler(this.$jsBridgeCmd.appIsReload, {isReload: false}, (data) => {})
            }
          } else {
            this.buttonLoading = false
            Toast(res.msg)
          }
        })
      } else {
        if (this.$route.query.isApp == 1 || this.isApp == 1) {
          this.$jsBridge.callHandler(this.$jsBridgeCmd.appLogin, {code: 200, type: 'login'}, (data) => {})
        } else {
          this.$router.push('/login?historyBack=' + window.encodeURIComponent(this.$route.path))
        }
      }

    },
    handleClose() {
      if (this.$route.query.isApp == 1 || this.isApp == 1) {
        this.$jsBridge.callHandler(this.$jsBridgeCmd.goBack, {}, (data) => {})
        // removeCookie('language')
      } else {
        this.$router.back()
      }
    },
    handleCreateFinish() {

    },
    handleConfirm(type) {
      if (type == '300141') {
        this.tipsModel = false
      } else {
        if (this.$route.query.isApp == 1 || this.isApp == 1) {
          this.$jsBridge.callHandler(this.$jsBridgeCmd.appRecharge, {code: 200}, (data) => {})
          return false
        } else {
          this.$router.push('/download')
          return false
        }
      }
    },
    nextStep(val) {
      const targetElement = document.getElementById('create-symbol-flow')
      targetElement.scrollIntoView({ behavior: 'smooth',top: 0 })
      if (val == 2) {
        this.currentStep = val
        this.protocol = this.$refs.firstStepDemo.firstTemp.protocol
        this.currencyAddress = this.$refs.firstStepDemo.firstTemp.currencyAddress
        this.$refs.secondStepDemo.currencyDetails = this.$refs.firstStepDemo.resultData.data
        this.existFlag = this.$refs.firstStepDemo.resultData.data.existFlag
        this.upFee = this.$refs.firstStepDemo.protocolDetail.upFee
        this.$refs.secondStepDemo.priceTickNum = '11'
        this.$refs.secondStepDemo.fileList = this.$refs.firstStepDemo.resultData.data.imgs ? [{url: this.$refs.firstStepDemo.resultData.data.imgs}] : []
        this.$refs.secondStepDemo.currencyLimitMsg = ''
        this.$refs.secondStepDemo.currencyFullLimitMsg = ''
        this.$refs.secondStepDemo.totalIssueAmountLimitMsg = ''
        this.$refs.secondStepDemo.priceTickLimitMsg = ''
        this.$refs.secondStepDemo.contentLimitMsg = ''
        this.$refs.secondStepDemo.memoLimitMsg = ''
        this.$refs.secondStepDemo.twitterLimitMsg = ''
        this.$refs.secondStepDemo.telegramLimitMsg = ''
        this.$refs.secondStepDemo.discordLimitMsg = ''
        this.$refs.secondStepDemo.secondTemp = {
          currency: this.$refs.firstStepDemo.resultData.data.currency || '',
          currencyFull: this.$refs.firstStepDemo.resultData.data.currencyFull || '',
          totalIssueAmount: this.$refs.firstStepDemo.resultData.data.totalIssueAmount || '',
          priceTick: '11',
          content: this.$refs.firstStepDemo.resultData.data.content || '',
          memo: ''
        }
        this.$refs.secondStepDemo.secondTemp2 = {
          blockchainQuery: '',
          imgs: this.$refs.firstStepDemo.resultData.data.imgs || '',
          issueTimeStamp: !this.$refs.firstStepDemo.resultData.data.issueTime ? '' : this.parseTime(this.$refs.firstStepDemo.resultData.data.issueTime),
          whitePaper: '',
          officialWebsite: this.$refs.firstStepDemo.resultData.data.officialWebsite || '',
          totalCirculation: this.$refs.firstStepDemo.resultData.data.totalCirculation || '',
          twitter: this.$refs.firstStepDemo.resultData.data.twitter || '',
          telegram: this.$refs.firstStepDemo.resultData.data.telegram || '',
          discord: this.$refs.firstStepDemo.resultData.data.discord || ''
        }
        this.$refs.secondStepDemo.secondTemp3 = {
          checkList: [],
          currencyInfoContentRequest: []
        }
      } else if (val == 3) {
        this.currentStep = val
        this.memo = this.$refs.secondStepDemo.secondTemp.memo
        this.currency = this.$refs.secondStepDemo.secondTemp.currency ? this.$refs.secondStepDemo.secondTemp.currency : this.$refs.firstStepDemo.resultData.data.currency
      } else if (val == 4) {
        this.createSubmitStatus = true
        posthog.capture('Button Clicked', {
          trigger:'h5_free_market_listing_process_page_confirm_button',
          name:'创建交易对流程页面-确认创建按钮-H5',
          pair: `${this.$refs.secondStepDemo.secondTemp.currency ? this.$refs.secondStepDemo.secondTemp.currency : this.$refs.firstStepDemo.resultData.data.currency}_usdt`,
          instance: this.$refs.secondStepDemo.secondTemp.memo,
          chain: this.$refs.firstStepDemo.firstTemp.protocol,
          contract: this.$refs.firstStepDemo.firstTemp.currencyAddress
        });
        if (!this.existFlag) {
          var data = {
            protocol: this.$refs.firstStepDemo.firstTemp.protocol,
            currencyAddress: this.$refs.firstStepDemo.firstTemp.currencyAddress,
            currency: this.$refs.secondStepDemo.secondTemp.currency ? this.$refs.secondStepDemo.secondTemp.currency : this.$refs.firstStepDemo.resultData.data.currency,
            currencyFull: this.$refs.secondStepDemo.secondTemp.currency ? this.$refs.secondStepDemo.secondTemp.currencyFull : this.$refs.firstStepDemo.resultData.data.currencyFull,
            priceTick: this.$refs.secondStepDemo.secondTemp.priceTick ? this.$refs.secondStepDemo.secondTemp.priceTick : this.$refs.firstStepDemo.resultData.data.priceTick,
            currencyDigit: this.$refs.firstStepDemo.resultData.data.currencyDigit,
            blockchainQuery: this.$refs.secondStepDemo.secondTemp2.blockchainQuery ? this.$refs.secondStepDemo.secondTemp2.blockchainQuery : this.$refs.firstStepDemo.resultData.data.blockchainQuery,
            content: this.$refs.secondStepDemo.secondTemp.content,
            memo: this.$refs.secondStepDemo.secondTemp.memo,
            totalIssueAmount: this.$refs.secondStepDemo.secondTemp.totalIssueAmount ? this.$refs.secondStepDemo.secondTemp.totalIssueAmount : this.$refs.firstStepDemo.resultData.data.totalIssueAmount,
            totalCirculation: this.$refs.secondStepDemo.secondTemp2.totalCirculation ? this.$refs.secondStepDemo.secondTemp2.totalCirculation : undefined,
            imgs: this.$refs.secondStepDemo.secondTemp2.imgs ? this.$refs.secondStepDemo.secondTemp2.imgs : undefined,
            issueTimeStamp: this.$refs.secondStepDemo.secondTemp2.issueTimeStamp ? new Date(this.$refs.secondStepDemo.secondTemp2.issueTimeStamp).getTime(): undefined,
            whitePaper: this.$refs.secondStepDemo.secondTemp2.whitePaper ? this.$refs.secondStepDemo.secondTemp2.whitePaper : undefined,
            officialWebsite: this.$refs.secondStepDemo.secondTemp2.officialWebsite ? this.$refs.secondStepDemo.secondTemp2.officialWebsite : undefined,
            twitter: this.$refs.secondStepDemo.secondTemp2.twitter ? this.$refs.secondStepDemo.secondTemp2.twitter : undefined,
            telegram: this.$refs.secondStepDemo.secondTemp2.telegram ? this.$refs.secondStepDemo.secondTemp2.telegram : undefined,
            discord: this.$refs.secondStepDemo.secondTemp2.discord ? this.$refs.secondStepDemo.secondTemp2.discord : undefined,
            isTokenWillingness: this.$refs.thirdStepDemo.thirdTemp.isTokenWillingness,
            email: this.$refs.thirdStepDemo.thirdTemp.email || undefined,
            referral: this.$refs.thirdStepDemo.thirdTemp.referral || undefined,
          }
          var arr = []
          if (this.$refs.secondStepDemo.secondTemp3.currencyInfoContentRequest.length > 0) {
            this.$refs.secondStepDemo.secondTemp3.currencyInfoContentRequest.forEach(v => {
              arr.push({
                content: v.content,
                language: v.language,
              })
            })
          } else {
            arr = []
          }
          data.currencyInfoContentRequest = arr
          console.log(data)
          createApi(data).then(res => {
            Toast(res.msg)
            if (res.code == '200') {
              this.createSubmitStatus = false
              this.currentStep = val
              this.currencyId = res.data.currencyId
              this.memoId = res.data.memoId
              this.imgs = res.data.imgs || 'https://img.superex.live/static/images/freeZoon/defaultIcon.png'
              this.$refs.fourthStepDemo.getDomains()
              this.$refs.fourthStepDemo.getCodesTion()
            }else {
              this.createSubmitStatus = false
            }
          })
        } else {
          var data = {
            currencyId: this.$refs.firstStepDemo.resultData.data.currencyId,
            memo: this.$refs.secondStepDemo.secondTemp.memo,
            currency: this.$refs.firstStepDemo.resultData.data.currency,
            protocol: this.$refs.firstStepDemo.firstTemp.protocol,
            currencyAddress: this.$refs.firstStepDemo.firstTemp.currencyAddress,
            isTokenWillingness: this.$refs.thirdStepDemo.thirdTemp.isTokenWillingness,
            email: this.$refs.thirdStepDemo.thirdTemp.email || undefined,
            referral: this.$refs.thirdStepDemo.thirdTemp.referral || undefined,
          }
          createMemo(data).then(res => {
            Toast(res.msg)
            if (res.code == '200') {
              this.createSubmitStatus = false
              this.currentStep = val
              this.currencyId = res.data.currencyId
              this.memoId = res.data.memoId
              this.imgs = res.data.imgs || 'https://img.superex.live/static/images/freeZoon/defaultIcon.png'
              this.$refs.fourthStepDemo.getDomains()
              this.$refs.fourthStepDemo.getCodesTion()
            }else {
              this.createSubmitStatus = false
            }
          })
        }
      }
    },
    prevStep(val) {
      this.currentStep = val
    },
    handleFAQ() {
      if (this.$route.query.isApp == 1 || this.isApp == 1) {
        this.$jsBridge.callHandler(this.$jsBridgeCmd.goBrowser, {code: 200, link: this.FAQUrl[this.language]}, (data) => {})
      } else {
        window.location.href = this.FAQUrl[this.language]
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/mixin";
@import "../../assets/css/variableName";

.flow-main {
  background-color: #FFFFFF;
  color: #000922;
  font-size: torem(14);

  .flow-main-title {
    margin: torem(16);

    /deep/ .van-icon {
      font-size: torem(22);
    }

    h1 {
      font-size: torem(18);
      font-weight: 600;
      margin: torem(24) 0;
    }
  }
}

.msg-tip-popup {
  /deep/ .van-popup__close-icon {
    color: #000922;
    font-size: torem(16);
  }

  .tip-message-box {
    width: torem(343);
    padding: torem(16);
    background-color: #FFFFFF;
    border-radius: torem(8);
    height: auto;
    text-align: center;
    margin-top: torem(20);

    .icon {
      width: torem(48);
      height: torem(48);
      margin: 0 auto;
    }

    p {
      margin: torem(16) 0;
      font-size: torem(14);
      color: #000922;
      line-height: 1.5;
    }

    /deep/ .van-button {
      width: 100%;
      height: auto;
      padding: torem(11) 0;
      font-size: torem(16);
      color: #000922;
      background-color: #FFC72B;
      border-radius: torem(4);
      border: none;
    }
  }
}

.tip-popup {
  padding-bottom: torem(100);

  /deep/ .van-popup__close-icon {
    color: #000922;
    font-size: torem(22);
  }

  .tip-popup-title {
    margin: torem(60) torem(16) torem(24);
    font-size: torem(18);
    font-weight: 600;
    color: #000922;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .FAQ-btn{
      color: #FFC72B;
    }
  }

  .tip-popup-description {
    margin: torem(16);
    font-size: torem(16);
    line-height: 1.5;

    .content {
      margin-bottom: torem(24);
      color: #000922;
    }

    .step-content {
      padding: torem(16);
      background-color: #F9F9F9;
      border-radius: torem(8);
      color: #000922;

      p {
        margin-bottom: torem(16);

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  /deep/ .van-button--large {
    width: 90%;
    position: absolute;
    bottom: auto;
    left: torem(16);
    right: torem(16);
    background-color: #FFC72B;
    color: #000922;
    font-size: torem(14);
    font-weight: 600;
    border: none;
    border-radius: torem(4);

  }
}
</style>


// WEBPACK FOOTER //
// src/view/freeZone/createSymbolFlow.vue